"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AlarmOn_exports = {};
__export(AlarmOn_exports, {
  default: () => AlarmOn_default
});
module.exports = __toCommonJS(AlarmOn_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18 5.62109L17.0234 6.77344L13.5859 3.88281L14.543 2.75L18 5.62109ZM7.41406 3.88281L3.97656 6.75391L3 5.62109L6.45703 2.75L7.41406 3.88281ZM10.5 4.35156C11.4375 4.35156 12.3164 4.52734 13.1367 4.87891C13.944 5.23047 14.6536 5.71224 15.2656 6.32422C15.8776 6.92318 16.3594 7.6263 16.7109 8.43359C17.0755 9.25391 17.2578 10.1263 17.2578 11.0508C17.2578 11.9753 17.0755 12.8411 16.7109 13.6484C16.3594 14.4688 15.8776 15.1849 15.2656 15.7969C14.6536 16.3958 13.944 16.8711 13.1367 17.2227C12.3164 17.5742 11.4375 17.75 10.5 17.75C9.5625 17.75 8.68359 17.5742 7.86328 17.2227C7.04297 16.8711 6.32682 16.3958 5.71484 15.7969C5.11589 15.1849 4.64062 14.4688 4.28906 13.6484C3.92448 12.8411 3.74219 11.9753 3.74219 11.0508C3.74219 10.1263 3.92448 9.25391 4.28906 8.43359C4.64062 7.6263 5.1224 6.92318 5.73438 6.32422C6.34635 5.71224 7.05599 5.23047 7.86328 4.87891C8.68359 4.52734 9.5625 4.35156 10.5 4.35156ZM10.5 16.2656C11.2292 16.2656 11.9128 16.1289 12.5508 15.8555C13.1888 15.582 13.7422 15.2109 14.2109 14.7422C14.6927 14.2604 15.0703 13.707 15.3438 13.082C15.6172 12.444 15.7539 11.7669 15.7539 11.0508C15.7539 10.3216 15.6172 9.64453 15.3438 9.01953C15.0703 8.38151 14.6927 7.82812 14.2109 7.35938C13.7422 6.89062 13.1888 6.51953 12.5508 6.24609C11.9128 5.97266 11.2292 5.83594 10.5 5.83594C9.77083 5.83594 9.08724 5.97266 8.44922 6.24609C7.8112 6.51953 7.2513 6.89062 6.76953 7.35938C6.30078 7.82812 5.92969 8.38151 5.65625 9.01953C5.38281 9.64453 5.24609 10.3216 5.24609 11.0508C5.24609 11.7669 5.38281 12.444 5.65625 13.082C5.92969 13.707 6.30078 14.2604 6.76953 14.7422C7.2513 15.2109 7.8112 15.582 8.44922 15.8555C9.08724 16.1289 9.77083 16.2656 10.5 16.2656ZM9.40625 12.1836L13.0977 8.49219L13.8984 9.29297L9.40625 13.7656L7.00391 11.3828L7.80469 10.6016L9.40625 12.1836Z",
      fill: "currentColor"
    }
  )
);
const SvgAlarmOn = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AlarmOn_default = SvgAlarmOn;
